import { CompoundFilterProviderProps } from '../../CompoundFilter.types';
import { CompoundFilterContext } from '../../CompoundFilter.context';
import { useCompoundFilterReducer } from '../../hooks';

export const CompoundFilterProvider = ({
  state,
  onChange,
  children,
}: CompoundFilterProviderProps) => {
  const dispatch = useCompoundFilterReducer({ state, onChange });

  return (
    <CompoundFilterContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </CompoundFilterContext.Provider>
  );
};
